import classNames from "classnames";
import React from "react";
import Loader from "react-loaders";

import styles from "./index.module.scss";

interface Props extends React.ImgHTMLAttributes<HTMLImageElement> {
  fallback?: string;
}

export const ImageWithLoader: React.NamedExoticComponent<Props> = React.memo(
  (props) => {
    const [{ loading, src }, setState] = React.useState({
      loading: true,
      src: props.src,
    });

    React.useEffect(() => {
      if (typeof window === "undefined") {
        return;
      }

      const onError = () => {
        setState({
          loading: false,
          src: props.fallback,
        });
      };

      const onLoad = () => {
        setState({
          loading: false,
          src,
        });
      };

      const img = new Image();

      img.addEventListener("error", onError);
      img.addEventListener("load", onLoad);
      img.src = src || "";

      return () => {
        img.removeEventListener("error", onError);
        img.removeEventListener("load", onLoad);
      };
    }, []);

    // eslint-disable-next-line @typescript-eslint/no-unused-vars,no-unused-vars
    const { fallback: _fallback, src: _src, unselectable, ...rest } = props;

    if (loading) {
      return (
        <div className={classNames(styles.loader, props.className)}>
          <Loader active type="ball-scale-multiple" />
        </div>
      );
    }

    return <img src={src} {...rest} />;
  },
);

export default ImageWithLoader;
